var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3688 156.647H148.926C162.329 156.647 168.75 150.075 168.75 136.869V68.7221C168.75 55.5805 162.329 48.964 148.926 48.964H51.3688C37.9 48.964 31.25 55.5169 31.25 68.7221V136.869C31.25 150.075 37.9 156.647 51.3688 156.647ZM139.629 83.7681H60.4568C58.0437 83.7681 56.25 81.898 56.25 79.5598C56.25 77.2879 58.0437 75.5524 60.4568 75.5524H139.629C142.02 75.5524 143.75 77.2879 143.75 79.5598C143.75 81.898 142.02 83.7681 139.629 83.7681ZM139.629 107.077H60.4568C58.0437 107.077 56.25 105.207 56.25 102.869C56.25 100.599 58.0437 98.8615 60.4568 98.8615H139.629C142.02 98.8615 143.75 100.599 143.75 102.869C143.75 105.207 142.02 107.077 139.629 107.077ZM112.999 130.386H60.4568C58.0437 130.386 56.25 128.582 56.25 126.313C56.25 123.975 58.0437 122.171 60.4568 122.171H112.999C115.327 122.171 117.121 123.975 117.121 126.313C117.121 128.582 115.327 130.386 112.999 130.386Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.4819 38.5283H153.746C152.783 32.6945 149.908 29.5929 143.491 29.5929H59.7375C53.3203 29.5929 50.445 32.6945 49.4819 38.5283Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.1057 20.6664H138.933C138.547 15.2174 135.341 12.5 129.437 12.5H73.6016C67.6977 12.5 64.4897 15.2174 64.1057 20.6664Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyForms);
export default __webpack_public_path__ + "static/media/EmptyForms.c3ae4f646c977446e380a577c546244a.svg";
export { ForwardRef as ReactComponent };